import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import ProductPage from "@/pages/ProductPage";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import CursorFollower from "@/components/CursorFollower";
import ScrollProgress from "@/components/ScrollProgress";
import { CartProvider } from "@/context/CartContext";

function App() {
  return (
    <CartProvider>
      <div className="App grain min-h-screen bg-[#0a0a0a] text-[#F5F5F7]">
        <ScrollProgress />
        <CursorFollower />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<ProductPage />} />
            <Route path="/success" element={<CheckoutSuccess />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          richColors
          closeButton
        />
      </div>
    </CartProvider>
  );
}

export default App;
